import React from 'react';
import cx from 'classnames';

import { UPLOAD_DOCUMENT_EXTENSIONS } from '../../../constants/allowed_extensions';
import { useIsSmallScreen } from '../../../hooks/useIsSmallScreen';
import IconTooltip from '../../IconTooltip';
import { H4, Paragraph } from '../../Typography';
import UploadDropZoneAlt from '../../UploadDropZoneAlt';
import { useUploadDocumentContext } from '../context';

import styles from '../UploadDocumentModal.module.scss';

const UploadStep = () => {
  const { handleFileDrop } = useUploadDocumentContext();
  const isSmallScreen = useIsSmallScreen();
  return (
    <div>
      <UploadDropZoneAlt
        id="lease_agreement_upload"
        name="lease_agreement_upload"
        label=""
        description={
          <div className={styles.dropZoneDescription}>
            <div className={styles.wrapper}>
              <H4>
                {isSmallScreen ? 'Tap to upload' : 'Click or drag to upload'}
              </H4>
              <IconTooltip
                icon="info"
                className={cx(styles.iconTooltip, styles.hideMobile)}
                tooltipClassName={styles.tooltip}
                tip={
                  <span className={styles.tooltipText}>
                    Files must be ≤20MB and one of these file types: CSV, DOCX,
                    JPG, PNG, PDF, TXT, XLSX, or ZIP.
                  </span>
                }
              />
            </div>
          </div>
        }
        accept={UPLOAD_DOCUMENT_EXTENSIONS.map((ext) => `.${ext}`).join(',')}
        multiple={false}
        iconProps={{ width: 34, height: 34 }}
        onFileDrop={(files) =>
          handleFileDrop({
            droppedFiles: files,
          })
        }
      />
      <div className={styles.mobileDisclaimer}>
        <Paragraph>
          Files must be ≤20MB and one of these file types: CSV, DOCX, JPG, PNG,
          PDF, TXT, XLSX, or ZIP.{' '}
        </Paragraph>
      </div>
    </div>
  );
};

export default UploadStep;
